const subscribers = {};
const EMPTY_LIST = [];
export const getSubscribers = (url) => {
    if (hasSubscribers(url)) {
        return Array.from(subscribers[url]);
    }
    return EMPTY_LIST;
};
export const hasSubscribers = (url) => {
    return subscribers[url]?.size > 0;
};
export const addSubscriber = (url, subscriber) => {
    subscribers[url] = subscribers[url] || new Set();
    subscribers[url].add(subscriber);
};
export const removeSubscriber = (url, subscriber) => {
    subscribers[url].delete(subscriber);
};
export const resetSubscribers = (url) => {
    if (url && subscribers.hasOwnProperty(url)) {
        delete subscribers[url];
    }
    else {
        for (let url in subscribers) {
            if (subscribers.hasOwnProperty(url)) {
                delete subscribers[url];
            }
        }
    }
};
//# sourceMappingURL=manage-subscribers.js.map